import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IPackagesItem } from '../../../modules/API/Defaults/models/packages';
import PackageBoxIcon from '../../icons/IconLib/PackageBoxIcon';

interface Props {
    packages: IPackagesItem[];
    value: IPackagesItem | null;
    onSelect: (pkg: IPackagesItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const PackageSelector: React.FC<Props> = ({
    packages,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<IPackagesItem>
            items={packages}
            value={value}
            onSelect={onSelect}
            getKey={(p) => p.PackID}
            getLabel={(p) => (p.Pack_Name ?? '').trim()}
            getSearchText={(p) => `${p.Pack_Name ?? ''} ${p.Pack_Size ?? ''}`}
            placeholder={placeholder ?? t('selectors_package_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            leadingIcon={<PackageBoxIcon />}
            className={className}
            emptyLabel={t('selectors_package_empty')}
        />
    );
};

export default PackageSelector;
